import { render, staticRenderFns } from "./ShipmentsList.vue?vue&type=template&id=d1675550&scoped=true"
import script from "./ShipmentsList.vue?vue&type=script&lang=js"
export * from "./ShipmentsList.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsList.vue?vue&type=style&index=0&id=d1675550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1675550",
  null
  
)

export default component.exports